export const parseMaybeJson = <T>(value: string | T, fallback?: T): T => {
  if (typeof value === "string") {
    try {
      return JSON.parse(value);
    } catch {
      return (fallback ?? value) as unknown as T;
    }
  }
  return value;
};
